module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop"
  }, [_c('h4', {
    staticClass: "desk_title"
  }, [_vm._v(_vm._s(_vm.ModalName))]), _vm._v(" "), _c('div', {
    staticClass: "app-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "t-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "t-input",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "30px",
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(_vm.g('$订单号/跟踪号/参考号/收件人')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text",
      "autosize": {
        minRows: 1,
        maxRows: 30
      }
    },
    model: {
      value: (_vm.OrderPage.SearchEntity.ONs2),
      callback: function($$v) {
        _vm.$set(_vm.OrderPage.SearchEntity, "ONs2", $$v)
      },
      expression: "OrderPage.SearchEntity.ONs2"
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "t-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "t-input",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "30px",
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(_vm.g('$SKU')) + " ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "78%"
    },
    attrs: {
      "type": "text",
      "autosize": {
        minRows: 1,
        maxRows: 30
      }
    },
    model: {
      value: (_vm.OrderPage.SearchEntity.SKUList),
      callback: function($$v) {
        _vm.$set(_vm.OrderPage.SearchEntity, "SKUList", $$v)
      },
      expression: "OrderPage.SearchEntity.SKUList"
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOrderSearchData),
      expression: "showOrderSearchData"
    }],
    staticClass: "order-search",
    staticStyle: {
      "margin-top": "40px",
      "width": "100%",
      "padding-left": "80px"
    },
    attrs: {
      "span": 18
    }
  }, [_c('page-search-table', {
    staticClass: "page_search_table orderListTable",
    attrs: {
      "store": _vm.OrderPage,
      "fieldData": _vm.OrderPage.SearchEntity
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('el-button', {
    staticClass: "filter-item",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showOrderSearch
    }
  }, [_vm._v(_vm._s(_vm.showOrderSearchData ? _vm.gets('$隐藏更多搜索项') : _vm.gets('$展开更多搜索项')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "comd orderListComd",
    staticStyle: {
      "float": "right",
      "padding-top": "0px",
      "margin-bottom": "10px"
    }
  }, [(_vm.isSee) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.OrderPage.Table.OnPageChange(1, this)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$查询')))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "method": "post",
      "action": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + '/Api/Order/SearchOrderWeightLists',
      "id": _vm.OrderPage.GN('SearchOrder') + 'FormRepeat'
    }
  }, [_c('input', {
    attrs: {
      "name": "datas",
      "id": _vm.OrderPage.GN('SearchOrder') + 'FormDataRepeat'
    }
  })]), _vm._v(" "), (_vm.isSee) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.ToExportOrderRepeat
    }
  }, [_vm._v(_vm._s(_vm.gets('$导出计费重量')))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "method": "post",
      "action": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + '/Api/Order/ExportOrder',
      "id": _vm.OrderPage.GN('SearchOrder') + 'Form'
    }
  }, [_c('input', {
    attrs: {
      "name": "datas",
      "id": _vm.OrderPage.GN('SearchOrder') + 'FormData'
    }
  })]), _vm._v(" "), (_vm.isSee) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.ToExportOrder
    }
  }, [_vm._v(_vm._s(_vm.gets('$导出')))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "method": "post",
      "action": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + '/Api/Order/ExportOrderLess',
      "id": _vm.OrderPage.GN('SearchOrder') + 'Formless'
    }
  }, [_c('input', {
    attrs: {
      "name": "datas",
      "id": _vm.OrderPage.GN('SearchOrder') + 'FormDataless'
    }
  })]), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "method": "post",
      "action": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + '/Api/Order/ExportOrderALL',
      "id": _vm.OrderPage.GN('SearchOrder') + 'ExportOrderALL'
    }
  }, [_c('input', {
    attrs: {
      "name": "datas",
      "id": _vm.OrderPage.GN('SearchOrder') + 'ExportOrderALLS'
    }
  })]), _vm._v(" "), (_vm.isSee) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.ToExportOrderALL
    }
  }, [_vm._v(_vm._s(_vm.gets('$导出所有')))]) : _vm._e(), _vm._v(" "), (_vm.isUpdate) ? _c('el-button', {
    staticClass: "filter-item",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.ToMarkingOrder(_vm.OrderPage)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$标记')))]) : _vm._e(), _vm._v(" "), (_vm.isUpdate) ? _c('el-button', {
    staticClass: "filter-item",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.ToRemarkOrder(_vm.OrderPage)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$备注')))]) : _vm._e(), _vm._v(" "), (_vm.isUpdate) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-refresh"
    },
    on: {
      "click": _vm.UpdateTrackNos
    }
  }, [_vm._v(_vm._s(_vm.gets('$批量更新跟踪号')))]) : _vm._e(), _vm._v(" "), (_vm.isUpdate) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-refresh"
    },
    on: {
      "click": _vm.UpdateYUNTU
    }
  }, [_vm._v(_vm._s(_vm.gets('$更新云途单号')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.AddModuleShow2 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$拦截订单')))]), _vm._v(" "), (_vm.isSee) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.AddModuleShow5 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$多状态导出')))]) : _vm._e(), _vm._v(" "), (_vm.isSee) ? _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.ShouBtnExport = true
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$选择列导出')))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "desk_title OrderListVueDT",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.OrderStatus),
      callback: function($$v) {
        _vm.OrderStatus = $$v
      },
      expression: "OrderStatus"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$确认') + '(' + _vm.GetCountByStatus(1) + ')',
      "name": '1'
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$已迁入') + '(' + _vm.GetCountByStatus(2) + ')',
      "name": '2'
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$处理中') + '(' + _vm.GetCountByStatus(7) + ')',
      "name": '7'
    }
  }, [(_vm.isSee) ? _c('el-button', {
    staticClass: "filter-item",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.ToPrintPOrder(_vm.OrderPage)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$打印派送标签')))]) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$已付款待发货') + '(' + _vm.GetCountByStatus(3) + ')',
      "name": '3'
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$已发货') + '(' + _vm.GetCountByStatus(4) + ')',
      "name": '4'
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$缺货') + '(' + _vm.GetCountByStatus(6) + ')',
      "name": '6'
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$问题件') + '(' + _vm.GetCountByStatus(5) + ')',
      "name": '5'
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$已作废') + '(' + _vm.GetCountByStatus(10) + ')',
      "name": '10'
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$草稿') + '(' + _vm.GetCountByStatus(0) + ')',
      "name": '0'
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.gets('$预报中') + '(' + _vm.GetCountByStatus(9) + ')',
      "name": '9'
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page_content"
    }
  }, [_c('l-table-page-view', {
    staticClass: "orderListBG",
    attrs: {
      "resultData": _vm.$store.state[_vm.OrderPage.GN('SearchOrder')],
      "TableConfig": _vm.OrderPage.Table
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.OrderPage.ShouBtnExport,
      "al-append-to-body": true,
      "append-to-body": true,
      "width": "800",
      "title": _vm.gets('$选择导出列')
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage, "ShouBtnExport", $event)
      }
    }
  }, [_c('div', {
    staticClass: "checkbox-container"
  }, _vm._l((_vm.$store.state[_vm.OrderPage.GN('OrderChoose')]), function(item) {
    return _c('div', {
      key: item.EnName,
      staticClass: "checkbox-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Chooses),
        expression: "item.Chooses"
      }],
      staticClass: "hidden-checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.Chooses) ? _vm._i(item.Chooses, null) > -1 : (item.Chooses)
      },
      on: {
        "change": function($event) {
          var $$a = item.Chooses,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "Chooses", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "Chooses", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "Chooses", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox-custom"
    }), _vm._v("\n                    " + _vm._s(_vm.lang == "EN" ? item.EnName : item.CnName) + "\n                ")])])
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v(_vm._s(_vm.gets('$全部选中')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.unselectAll
    }
  }, [_vm._v(_vm._s(_vm.gets('$全部取消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.ToChooseExportOrder
    }
  }, [_vm._v(_vm._s(_vm.gets('$导出')))]), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "method": "post",
      "action": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + '/Api/Order/NewExportOrders',
      "id": _vm.OrderPage.GN('SearchOrder') + 'NewExclFrom'
    }
  }, [_c('input', {
    attrs: {
      "name": "datas",
      "id": _vm.OrderPage.GN('SearchOrder') + 'NewFormData'
    }
  })])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.OrderPage.AddModuleShow5,
      "modal-append-to-body": true,
      "append-to-body": true,
      "width": "800",
      "title": _vm.gets('$订单多选状态导出')
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage, "AddModuleShow5", $event)
      }
    }
  }, [_c('form-list', {
    attrs: {
      "fieldData": _vm.OrderPage.Search2,
      "entity": _vm.OrderPage.Search2
    }
  }), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "method": "post",
      "action": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + '/Api/Order/ExportOrder',
      "id": _vm.OrderPage.GN('SearchOrder') + 'Form2'
    }
  }, [_c('input', {
    attrs: {
      "name": "datas",
      "id": _vm.OrderPage.GN('SearchOrder') + 'FormData2'
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.AddModuleShow5 = false
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.ToExportOrder2
    }
  }, [_vm._v(_vm._s(_vm.gets('$导出')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.OrderPage.AddModuleShow,
      "modal-append-to-body": true,
      "append-to-body": true,
      "width": "800",
      "title": _vm.gets('$批量修改')
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage, "AddModuleShow", $event)
      }
    }
  }, [_c('form-list', {
    attrs: {
      "store": _vm.OrderPage,
      "entity": _vm.OrderPage.Entity
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.AddModuleShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))]), _vm._v(" "), (_vm.isAdd) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateOrders(_vm.OrderPage, this)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$确定')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.OrderPage.AddModuleShow2,
      "modal-append-to-body": true,
      "append-to-body": true,
      "width": "800",
      "title": _vm.gets('$拦截订单')
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage, "AddModuleShow2", $event)
      }
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#f56c6c",
      "margin-bottom": "20px",
      "line-height": "1.6"
    }
  }, [_vm._v("\n  1、远邮、跨境，需发给渠道拦截处理"), _c('br'), _vm._v("\n  2、修改地址的订单不需要拦截，提供地址给渠道发物流商修改地址\n")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.gets('$订单号')
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.gets('$订单号')))]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.orders),
      callback: function($$v) {
        _vm.orders = $$v
      },
      expression: "orders"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.gets('$拦截原因')
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.gets('$拦截原因')))]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.AddModuleShow2 = false
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.InterceptOredr()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$确定')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "modal-append-to-body": true,
      "append-to-body": true,
      "visible": _vm.OrderPage.IsMergeOrder,
      "width": "800",
      "title": _vm.gets('$合并订单')
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage, "IsMergeOrder", $event)
      }
    }
  }, [(_vm.$store.state[_vm.OrderPage.GN('OrderTableSelectCheckbox')]) ? _c('div', [_c('p', {
    staticClass: "bg-danger"
  }, [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.gets('$请先选择一个订单作为合并的基准订单')) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "page_content",
    staticStyle: {
      "display": "initial"
    },
    attrs: {
      "id": "page_content"
    }
  }, [(_vm.$store.state[_vm.OrderPage.GN('OrderTableSelectCheckbox')]) ? _c('l-table-view', {
    attrs: {
      "DataArr": _vm.$store.state[_vm.OrderPage.GN('OrderTableSelectCheckbox')],
      "TableConfig": _vm.OrderPage.Table2
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.IsMergeOrder = false
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))]), _vm._v(" "), (_vm.isAdd) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.MergeOrder(_vm.OrderPage, this)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$确定')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "modal-append-to-body": true,
      "append-to-body": true,
      "visible": _vm.OrderPage.IsCopyOrder,
      "width": "800",
      "title": _vm.gets('$复制订单')
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage, "IsCopyOrder", $event)
      }
    }
  }, [_c('div', [_c('p', {
    staticClass: "bg-danger"
  }, [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.gets('$请输入一个需要复制的参考号或者订单号')) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "page_content",
    staticStyle: {
      "display": "initial"
    },
    attrs: {
      "id": "page_content"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.gets('$参考号/订单号')
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.gets('$参考号/订单号')))]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.CopyNo),
      callback: function($$v) {
        _vm.CopyNo = $$v
      },
      expression: "CopyNo"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.IsCopyOrder = false
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))]), _vm._v(" "), (_vm.isAdd) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.CopyOrder(_vm.OrderPage, this)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$确定')))]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "modal-append-to-body": true,
      "append-to-body": true,
      "visible": _vm.OrderPage.IsMarkingOrder,
      "width": "800",
      "title": _vm.gets('$标记订单')
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage, "IsMarkingOrder", $event)
      }
    }
  }, [(_vm.$store.state[_vm.OrderPage.GN('OrderTableSelectCheckbox')]) ? _c('div', [_c('div', {
    staticClass: "page_content",
    staticStyle: {
      "display": "initial"
    },
    attrs: {
      "id": "page_content"
    }
  }, [_c('div', {
    staticClass: "xgxxrow",
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('table', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%",
      "border": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v(_vm._s(_vm.gets('$标记名称')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v(_vm._s(_vm.gets('$标记颜色')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.gets('$操作')))])]), _vm._v(" "), _vm._l((_vm.$store.state[_vm.OrderPage.GN('ColorMark')]), function(i) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#fff"
      },
      attrs: {
        "bgcolor": i.Color
      }
    }, [_c('span', {
      staticStyle: {
        "width": "100%",
        "display": "block",
        "color": "rgb(255, 255, 255)"
      },
      attrs: {
        "onclick": "ShowEdit('1')"
      }
    }, [_vm._v(" " + _vm._s(i.Text))])]), _vm._v(" "), _c('td', {
      attrs: {
        "nowrap": "nowrap",
        "bgcolor": i.Color
      }
    }, [_vm._v(" " + _vm._s(i.Color))]), _vm._v(" "), _c('td', [_c('el-button', {
      staticClass: "filter-item",
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "size": "mini",
        "plain": "",
        "type": "primary",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.MarkingOrder(i.Color, i.EnName, i.CnName)
        }
      }
    }, [_vm._v(_vm._s(_vm.gets('$标记')))])], 1)])
  })], 2)])])])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "modal-append-to-body": true,
      "append-to-body": true,
      "visible": _vm.IsTips,
      "width": "800",
      "title": _vm.gets('$提示')
    },
    on: {
      "update:visible": function($event) {
        _vm.IsTips = $event
      }
    }
  }, [_c('div', [_c('p', {
    staticClass: "bg-danger"
  }, [_c('ul', [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.Tips)
    }
  }, [_vm._v("OK\n                        ")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.IsTips = false
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "modal-append-to-body": true,
      "append-to-body": true,
      "visible": _vm.OrderPage.IsRemarkOrder,
      "width": "800",
      "title": _vm.gets('$备注订单')
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage, "IsRemarkOrder", $event)
      }
    }
  }, [_c('div', {
    staticClass: "page_content",
    staticStyle: {
      "display": "initial"
    },
    attrs: {
      "id": "page_content"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.gets('$备注')
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.gets('$备注')))]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.Remark),
      callback: function($$v) {
        _vm.Remark = $$v
      },
      expression: "Remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.IsRemarkOrder = false
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.RemarkOrder(_vm.OrderPage, this)
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$确定')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "modal-append-to-body": true,
      "append-to-body": true,
      "visible": _vm.OrderPage.UploadTrackingNos.ModuleShow,
      "width": "800",
      "title": _vm.OrderPage.UploadTrackingNos.ModalName
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.OrderPage.UploadTrackingNos, "ModuleShow", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "45px"
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "uploadify-button-text",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "id": "UploadTrackingNos_file_upload"
    }
  }, [_vm._v(_vm._s(_vm.gets("$上传")))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.OrderPage.UploadTrackingNos.templateurl()
      }
    }
  }, [_vm._v(_vm._s(_vm.gets("$下载导入模板")))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), (_vm.$store.state[_vm.OrderPage.GN('UploadTrackingNos_file_upload')]) ? _c('div', [_c('div', {
    staticClass: "page_content",
    staticStyle: {
      "display": "initial"
    },
    attrs: {
      "id": "page_content"
    }
  }, [(_vm.$store.state[_vm.OrderPage.GN('UploadTrackingNos_file_upload')].data) ? _c('l-table-view', {
    attrs: {
      "DataArr": _vm.$store.state[_vm.OrderPage.GN('UploadTrackingNos_file_upload')].data,
      "TableConfig": _vm.OrderPage.UploadTrackingNos.Table
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.OrderPage.UploadTrackingNos.ModuleShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$取消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function() {
        var d = _vm.$store.state[_vm.OrderPage.GN('UploadTableSelectCheckboxTrackingNos')];
        _vm.OrderPage.UploadTrackingNos.ModuleShow = false;
        _vm.OrderPage.UploadTrackingNos.Update(d, function() {
          _vm.OrderPage.SearchPageData();
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$确定')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.InterceptdialogVisible,
      "title": "订单处理结果",
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.InterceptdialogVisible = $event
      },
      "close": _vm.clearResults
    }
  }, [(_vm.orderResults.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderResults
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "OrderNO",
      "label": "订单号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Message",
      "label": "执行结果"
    }
  })], 1) : _c('p', [_vm._v("正在获取订单数据...")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.InterceptdialogVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e548a8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/Order/OrderList.vue
// module id = 1278
// module chunks = 169